import {
  type MenuItemTrackingEvent,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

export type NavigationEvent = MenuItemTrackingEvent;

export const useNavigationAnalytics = () =>
  useAnalyticsTracker<NavigationEvent>(TrackObject.NAVIGATION);
